export class Token {
  public static readonly tokenNameInStorage = 'jwt';
  public static readonly refreshTokenNameInStorage = 'refreshToken';
  public static readonly scheme = 'Bearer ';
}
